import {
    NinchatActionType,
    NinchatUpdateQueueAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateQueue = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateQueueAction}`,
    async (arg: NinchatActionParams<NinchatUpdateQueueAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateQueueAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
